import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api, {UpdateApiKeyBody} from 'src/services/api'
type Props = {
  body: UpdateApiKeyBody
  id: number
}
export default function useUpdateApiKey() {
  const {enqueueSnackbar} = useSnackbar()
  const client = useQueryClient()
  const mutation = useMutation({
    mutationFn: async ({body, id}: Props) => {
      return await api.auth.updateApiKey(id, body)
    },
    onSuccess: async () => {
      enqueueSnackbar('Status da chave alterado com sucesso', {variant: 'success'})
      await client.invalidateQueries({queryKey: ['list-api-keys']})
    },
    onError: () => enqueueSnackbar('Não conseguimos alterar o status da chave', {variant: 'error'}),
  })
  return mutation
}
